import infection from "../../assets/icons/categories/infection.svg";
import antiInfectives from "../../assets/icons/categories/anti-infectives.svg";
import microorganisms from "../../assets/icons/categories/microorganisms.svg";
import spilf from "../../assets/images/partners/spilf.png";
import mesVaccins from "../../assets/images/partners/mes-vaccins-net-medium.png";
import decisionTree from "../../assets/icons/categories/decision-tree.svg";
import { CategoryCard } from "./CategoryCard";

interface CategoriesProps {
  isAuth: boolean;
}

const HomeCategories = ({ isAuth }: CategoriesProps) => {
  return (
    <div className={`categories content ${!isAuth ? "not-auth" : ""}`}>
      {!isAuth && (
        <h2 className="categories__title">
          L'expertise en infectiologie à portée de clic.
        </h2>
      )}
      <div className="categories__container">
        <div className="categories__content">
          <CategoryCard
            id={1}
            name="Infection"
            description="260 maladies infectieuses traitées : de l’épidémiologie à la prescription"
            icon={infection}
          />
          <CategoryCard
            id={3}
            name="Anti-infectieux"
            description="Aide à la prescription pour favoriser le bon usage des anti-infectieux"
            icon={antiInfectives}
          />
          <CategoryCard
            id={2}
            name="Microorganismes"
            description="Près de 250 agents infectieux : bactéries, virus, parasites, champignons"
            icon={microorganisms}
          />
          <CategoryCard
            id={4}
            name="Vaccins"
            description="Consulter les fiches vaccins de MesVaccins.net"
            icon={mesVaccins}
          />
          <CategoryCard
            id={5}
            name="Antibioprophylaxie en chirurgie"
            size="medium"
          />
          <CategoryCard
            id={6}
            name="Accidents d'exposition au sang et aux liquides biologiques"
            size="medium"
          />
        </div>
        <div className="categories__content--small">
          <CategoryCard
            id={7}
            name="Outil d'aide à la prescription"
            size="medium"
            link="/aide-prescription"
            icon={decisionTree}
          />

          <CategoryCard
            id={8}
            name="Recommandations de la SPILF"
            icon={spilf}
            size="medium"
            link="https://www.infectiologie.com/fr/recommandations.html"
          />
          <CategoryCard
            id={10}
            name="Outil d'aide à l'administration"
            size="medium"
            link="/aide-administration"
            icon={decisionTree}
          />
          <CategoryCard
            id={9}
            name="MentorPro"
            description="Outil d'aide à la décision Vaccinale"
            link={"/mentorpro/"}
            icon={mesVaccins}
          />
        </div>
      </div>
    </div>
  );
};

export default HomeCategories;
